import { CopyToClipboardConditionalFormComponent } from "components/Form/components/CopyToClipboard/CopyToClipboardConditionalFormComponent";
import { CopyToClipboardFormComponent } from "components/Form/components/CopyToClipboard/CopyToClipboardFormComponent";
import { DateFormComponent } from "components/Form/components/Date/DateFormComponent";
import { NumberFormComponent } from "components/Form/components/Number/NumberFormComponent";
import { PasswordFormComponent } from "components/Form/components/Password/PasswordFormComponent";
import { SwitchFormComponent } from "components/Form/components/Switch/SwitchFormComponent";
import { TextareaFormComponent } from "components/Form/components/Textarea/TextareaFormComponent";
import { TimeFormComponent } from "components/Form/components/Time/TimeFormComponent";
import { ToggleFormComponent } from "components/Form/components/Toggle/ToggleFormComponent";
import { SettingReferencesFormComponent } from "components/Form/components/Url/SettingReferencesFormComponent";
import { UrlFormComponent } from "components/Form/components/Url/UrlFormComponent";
import { WebhookSecurityFormComponent } from "components/Form/components/WebhookSecurity/WebhookSecurityFormComponent";
import { WriteOnlyInputFormComponent } from "components/Form/components/WriteOnlyInput/WriteOnlyInputFormComponent";
import {
    LazyResizeableCodeEditor,
    LazySchemaFormConditionalFormComponent,
    LazySchemaFormFormComponent,
    LazyVisualCodeEditor,
} from "components/Form/lazyFormComponents";
import { ContentEncodingFormComponent } from "./components/FileMeta/ContentEncodingFormComponent";
import { ContentTypeFormComponent } from "./components/FileMeta/ContentTypeFormComponent";
import { FileSizeFormComponent } from "./components/FileMeta/FileSizeFormComponent";
import { AllowedValuesEditor } from "./components/AllowedValuesEditor/AllowedValuesEditor";
import { DefaultValueEditor } from "./components/DefaultValueEditor/DefaultValueEditor";
import { IncomingReferenceAttributeEditor } from "./components/IncomingReferenceAttributeEditor/IncomingReferenceAttributeEditor";
import { RecordFilterBuilderFormComponent } from "./components/RecordFilterBuilder/RecordFilterBuilderFormComponent";
import { AutocompleteFormComponent } from "./components/Autocomplete/AutocompleteFormComponent";
import { Checkbox } from "./components/Checkbox/Checkbox";
import { CheckboxGroupFormComponent } from "./components/CheckboxGroup/CheckboxGroupFormComponent";
import { DateTimeFormComponent } from "./components/DateTime/DateTimeFormComponent";
import { Email } from "./components/Email/Email";
import { ExtendedAutocompleteFormComponent } from "./components/ExtendedAutocomplete/ExtendedAutocompleteFormComponent";
import { Hidden } from "./components/Hidden/Hidden";
import { ImageUpload } from "./components/ImageUpload/ImageUpload";
import { MarkdownFormComponent } from "./components/Markdown/MarkdownFormComponent";
import { Radio } from "./components/Radio/Radio";
import { RadioGroup } from "./components/RadioGroup/RadioGroup";
import { SwitchContentFormComponent } from "./components/SwitchContent/SwitchContentFormComponent";
import { TextFormComponent } from "./components/Text/TextFormComponent";
import { Value } from "./components/Value/Value";

//  List of fields that can be used in Form Generator
export const stringToFormFieldComponent = {
    text: TextFormComponent,
    textarea: TextareaFormComponent,
    url: UrlFormComponent,
    settingReferences: SettingReferencesFormComponent,
    email: Email,
    password: PasswordFormComponent,
    number: NumberFormComponent,
    radio: Radio,
    radioGroup: RadioGroup,
    checkbox: Checkbox,
    checkboxGroup: CheckboxGroupFormComponent,
    switch: SwitchFormComponent,
    hidden: Hidden,
    imageUpload: ImageUpload,
    codeEditor: LazyResizeableCodeEditor,
    schemaForm: LazySchemaFormFormComponent,
    schemaFormConditional: LazySchemaFormConditionalFormComponent,
    visualCodeEditor: LazyVisualCodeEditor,
    autocomplete: AutocompleteFormComponent,
    time: TimeFormComponent,
    value: Value,
    markdown: MarkdownFormComponent,
    dateTime: DateTimeFormComponent,
    date: DateFormComponent,
    writeOnlyInput: WriteOnlyInputFormComponent,
    copyToClipboard: CopyToClipboardFormComponent,
    copyToClipboardConditional: CopyToClipboardConditionalFormComponent,
    toggle: ToggleFormComponent,
    switchContent: SwitchContentFormComponent,
    webhookSecurity: WebhookSecurityFormComponent,
    extendedAutocomplete: ExtendedAutocompleteFormComponent,
    allowedValuesEditor: AllowedValuesEditor,
    defaultValueEditor: DefaultValueEditor,
    incomingReferenceAttributeEditor: IncomingReferenceAttributeEditor,
    recordFilterBuilder: RecordFilterBuilderFormComponent,
    fileSize: FileSizeFormComponent,
    contentType: ContentTypeFormComponent,
    contentEncoding: ContentEncodingFormComponent,
};

// maps form field to a parser that is applied to the form field value on change
// eg. allows the react-final-form value to provide an int for a number field instead of string
export const stringToFormFieldParser = {
    number: (value) => parseInt(value, 10),
};
